import { __decorate, __extends } from "tslib";
import React from 'react';
import { EnumHelper, Utils } from '@singularsystems/neo-core';
import { observer } from 'mobx-react';
import { BindPropsHelper } from './PropTypes';
import ComponentBase from './ComponentBase';
import { FormContext } from './FormContext';
import LookupHelper from './DropDown/LookupHelper';
var RadioList = /** @class */ (function (_super) {
    __extends(RadioList, _super);
    function RadioList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.items = [];
        return _this;
    }
    RadioList.prototype.preRender = function () {
        if (this.props.radioList.items && this.props.radioList.items !== this.previousList) {
            this.previousList = this.props.radioList.items;
            this.createEnumList(this.props.radioList.items);
        }
        else if (this.props.radioList.enumType && this.props.radioList.enumType !== this.previousEnumType) {
            this.previousEnumType = this.props.radioList.enumType;
            this.items = EnumHelper.asList(this.props.radioList.enumType);
        }
    };
    RadioList.prototype.createEnumList = function (list) {
        var _a, _b;
        if (list.length) {
            var _c = LookupHelper.findMembers(list[0], (_a = this.props.radioList.valueMember) !== null && _a !== void 0 ? _a : "", (_b = this.props.radioList.displayMember) !== null && _b !== void 0 ? _b : "", true), valueMember_1 = _c.valueMember, displayMember_1 = _c.displayMember;
            if (valueMember_1 && displayMember_1) {
                this.items = list.map(function (item) { return ({ id: item[valueMember_1], name: item[displayMember_1] }); });
            }
        }
    };
    RadioList.prototype.render = function () {
        var _this = this;
        var _a;
        this.preRender();
        var splitProps = BindPropsHelper.normaliseEditorProps(this, this.props);
        var domProps = BindPropsHelper.autoSetDomProperties(splitProps, this.context);
        // TODO, how must validation show if not in form group?
        //const displayInfo = this.props.bind.validator.getDisplayState(this.context.validationDisplayMode);
        //displayInfo.applyToDom(domProps, !splitProps.inGroup);
        var bindValue = this.props.bind.value;
        var className = Utils.joinWithSpaces("neo-radio-list", (_a = splitProps.editorDom) === null || _a === void 0 ? void 0 : _a.className);
        return React.createElement("div", { className: className }, this.items.map(function (item) {
            var _a, _b;
            return React.createElement("div", { className: "custom-control custom-radio " + (_this.props.radioList.inline ? "custom-control-inline" : "custom-control"), key: item.id },
                React.createElement("input", { type: "radio", id: splitProps.uniqueID + ((_a = item.id) !== null && _a !== void 0 ? _a : ""), name: splitProps.uniqueID, checked: bindValue === item.id, disabled: domProps.disabled || domProps.readOnly, onChange: function () { return _this.props.bind.value = item.id; }, className: "custom-control-input" }),
                React.createElement("label", { className: "custom-control-label", htmlFor: splitProps.uniqueID + ((_b = item.id) !== null && _b !== void 0 ? _b : "") }, item.name));
        }));
    };
    RadioList.contextType = FormContext;
    RadioList = __decorate([
        observer
    ], RadioList);
    return RadioList;
}(ComponentBase));
export default RadioList;
